import type { SpreadReadingProfile } from "../types";

export const treeOfLifeReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_tree_of_life",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

